module.exports = __webpack_public_path__ + "static/media/vehicle11.f6c5bc96.svg";